"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero" className="relative flex min-h-[80vh] items-center justify-center overflow-hidden bg-background py-40 md:py-48">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.03] mix-blend-multiply dark:opacity-[0.02] dark:mix-blend-screen">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/itc_plus_watermark_logo_large.png" alt="" className="h-[150%] w-auto max-w-none object-contain" aria-hidden="true" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="font-serif text-4xl font-bold leading-tight tracking-normal text-foreground md:text-5xl lg:text-6xl">
            Produtora de vídeo em São Paulo para empresas que querem se posicionar
          </h1>
          
          <p className="mt-6 max-w-2xl font-sans text-lg text-muted-foreground md:text-xl">
            Eleve o padrão da sua comunicação com produções audiovisuais de excelência. Criamos vídeos estratégicos que conectam sua marca ao público certo e geram resultados reais.
          </p>
          
          <div className="mt-10">
            <Button asChild size="lg" className="h-14 rounded-full bg-primary px-8 text-lg font-medium text-primary-foreground shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:bg-primary/90">
              <Link to="#">
                Fale com um especialista
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}